function f_aspectRatioIframe() {
    const percent = 0.7; /* porcentaje de reducción de los márgenes mínimos entre el video y el navegador */
    const videoWidth = 320; /* resolución horizontal del video original */
    const videoHeight = 568; /* resolución vertical del video original */
    var browserWidth = window.innerWidth;
    var browserHeight = window.innerHeight;
    var videoAspect = videoWidth / videoHeight;
    var browserAspect = browserWidth / browserHeight;
    var coef = videoAspect / browserAspect;
    if (videoAspect < browserAspect) {
        var modalHeight = Math.round(browserHeight * percent);
        var modalWidth = Math.round(browserWidth * percent * coef);
    } else {
        var modalWidth = Math.round(browserWidth * percent);
        var modalHeight = Math.round(browserHeight * percent / coef);
    }
    modalWidth = modalWidth.toString() + 'px';
    modalHeight = modalHeight.toString() + 'px';
    $('.modal__iframe').css({
        "width": modalWidth,
        "height": modalHeight
    });
}

$(document).ready(function () {

    // Para ajustar el width y height de los iframe
    f_aspectRatioIframe();

    $(".path__click").click(function(){
        var modalName = $(this).attr("data-modal");
        var selector = "[data-name='" + modalName + "']";
        $(selector).addClass("show");
        $("body").addClass("show__modal");
    });

    $(".btn__close").click( function(){
        var mparent = $(this).parents(".modal__window");
        $(mparent).find(".modal__iframe")[0].contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');
        $(mparent).removeClass("show");
        $("body").removeClass("show__modal");
    });

});